__turbopack_context__.v({
  "bookingLink": "PulsePopup-module__V0dC4q__bookingLink",
});
